import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { ChipFill, ChipSize } from '@lyceo/shared/util-models';
import { PREFIX_DIRECTIVE, PrefixDirective } from '../prefix.directive';
import { SUFFIX_DIRECTIVE, SuffixDirective } from '../suffix.directive';

@Component({
  selector: 'lyceo-chip',
  imports: [],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'lyceo-chip',
    '[class.disabled]': 'disabled()',
    '[class.icon-start]': 'hasIconPrefix()',
    '[class.icon-end]': 'hasIconSuffix()',
    '[class.fill-solid]': 'fill() === ChipFill.SOLID',
    '[class.fill-outline]': 'fill() === ChipFill.OUTLINE',
    '[class.size-small]': 'size() === ChipSize.SMALL',
    '[class.size-medium]': 'size() === ChipSize.MEDIUM',
  },
})
export class ChipComponent {
  public disabled: InputSignal<boolean> = input(false);
  public fill: InputSignal<ChipFill> = input<ChipFill>(ChipFill.SOLID);
  public size: InputSignal<ChipSize> = input<ChipSize>(ChipSize.MEDIUM);

  protected readonly ChipFill: typeof ChipFill = ChipFill;
  protected readonly ChipSize: typeof ChipSize = ChipSize;

  protected hasIconPrefix: Signal<boolean> = computed(
    () => !!this.prefixChildren().find((p) => !p.isText),
  );
  protected hasIconSuffix: Signal<boolean> = computed(
    () => !!this.suffixChildren().find((p) => !p.isText),
  );

  private readonly prefixChildren: Signal<readonly PrefixDirective[]> =
    contentChildren(PREFIX_DIRECTIVE, { descendants: true });
  private readonly suffixChildren: Signal<readonly SuffixDirective[]> =
    contentChildren(SUFFIX_DIRECTIVE, { descendants: true });
}
